import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './authShared.css';
import { useLogin } from '../hooks/useLogin';
import { useTheme } from '../ThemeContext';
import logoLight from '../images/QuiblyLight.png';
import logoDark from '../images/QuiblyDark.png';

const Login = () => {
  const { darkMode } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, error, isLoading } = useLogin();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await login(email, password);
    if (success) {
      navigate('/app/resume');
    }
  };

  return (
    <div className={`authPage ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="authCard">
        <Link to="/" className="authLogoLink">
          <img src={darkMode ? logoDark : logoLight} alt="Quibly" className="authLogo" />
        </Link>

        <h1 className="authTitle">Welcome back</h1>
        <p className="authSubtitle">Log in to build and tailor your resumes</p>

        <form className="authForm" onSubmit={handleSubmit}>
          <div className="authField">
            <label className="authLabel" htmlFor="login-email">Email</label>
            <input
              id="login-email"
              className="authInput"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              autoComplete="email"
              required
            />
          </div>

          <div className="authField">
            <label className="authLabel" htmlFor="login-password">Password</label>
            <input
              id="login-password"
              className="authInput"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Your password"
              autoComplete="current-password"
              required
            />
          </div>

          {error && <div className="authError">{error}</div>}

          <button type="submit" className="authBtn solid" disabled={isLoading}>
            {isLoading ? 'Logging in…' : 'Log in'}
          </button>
        </form>

        <p className="authFooter">
          Don&apos;t have an account? <Link to="/register">Sign up</Link>
        </p>
        <p className="authLinkRow">
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
